import { render, staticRenderFns } from "./SharedCollectionsView.vue?vue&type=template&id=6d8a34f1&"
import script from "./SharedCollectionsView.vue?vue&type=script&lang=js&"
export * from "./SharedCollectionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports